import React from 'react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { useDeleteWithConfirmation } from '../../../hooks/useDeleteWithConfirmation'

export default function Index({
  account,
  accounts,
  navigation,
  event_types,
  is_admin
}) {
  const handleDelete = useDeleteWithConfirmation('/manage/event_types')

  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (value, item) => (
        <div>
          <div className="font-medium text-gray-900">
            {item.icon && <span className="mr-1">{item.icon}</span>}
            {value}
          </div>
          {item.tagline && (
            <div className="text-gray-500 text-sm truncate max-w-xs">{item.tagline}</div>
          )}
        </div>
      )
    },
    {
      key: 'package_count',
      label: 'Packages',
      className: 'text-gray-500'
    },
    {
      key: 'active',
      label: 'Status',
      render: (value) => (
        <span className={`inline-flex rounded-full px-2 py-1 text-xs font-semibold ${
          value ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
        }`}>
          {value ? 'Active' : 'Inactive'}
        </span>
      )
    }
  ]

  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="Event Types"
      is_admin={is_admin}
    >
      <ResourceIndexHeader
        count={event_types.length}
        singular="event type"
        plural="event types"
        addHref="/manage/event_types/new"
        addLabel="Add Event Type"
      />

      <p className="mb-4 -mt-4 text-sm text-gray-500">
        Event types are the occasions guests can book — weddings, wakes, corporate days.
        Tag packages with an event type here or from the package itself.
      </p>

      <DataTable
        data={event_types}
        columns={columns}
        actions={(item) => (
          <>
            <Button link href={`/manage/event_types/${item.id}/edit`}>Edit</Button>
            <Button link variant="danger" onClick={() => handleDelete(item)}>Delete</Button>
          </>
        )}
        searchable={true}
        searchPlaceholder="Search event types..."
        emptyState={{
          message: 'No event types found',
          action: { label: 'Add your first event type', href: '/manage/event_types/new' }
        }}
        baseUrl="/manage/event_types"
      />
    </Layout>
  )
}
